// extracted by mini-css-extract-plugin
export default {"imageSize":"FavoriteFood_imageSize__1vUTu","likesText":"FavoriteFood_likesText__0fEmH"};